import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthUser } from '../../interfaces/auth.interface';

@Component({
  selector: 'app-staff-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './staff-header.component.html',
  styleUrl: './staff-header.component.scss'
})
export class StaffHeaderComponent {
  @Input() currentUser: AuthUser | null = null;
  @Output() logout = new EventEmitter<void>();

  onLogout(): void {
    this.logout.emit();
  }
} 